import { inject } from './inject';
import { LegalStatements as BaseLegalStatements } from './LegalStatements';

export const LegalStatements = inject(BaseLegalStatements);
